import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type AppConfig = {
  algoliaAppId: string;
  algoliaSearchApiKey: string;
  algoliaRecommendationsApiKey: string;
  topsortProxyUrl: string;
  topsortJsApiKey: string;
  googleTagManager: string;
  googleTagManagerAuth: string;
  googleTagManagerEnv: string;
  googleRecaptchaV1: string;
  googleRecaptchaV3: string;
  klaviyo: string;
  abTastyKey: string;
  stripe: string;
  deployedEnv: string;
};

const initialState: AppConfig = {
  algoliaAppId: "",
  algoliaSearchApiKey: "",
  algoliaRecommendationsApiKey: "",
  topsortProxyUrl: "",
  topsortJsApiKey: "",
  googleTagManager: "",
  googleTagManagerAuth: "",
  googleTagManagerEnv: "",
  googleRecaptchaV1: "",
  googleRecaptchaV3: "",
  klaviyo: "",
  abTastyKey: "",
  stripe: "",
  deployedEnv: "",
};

export const configSlice = createSlice({
  name: "config",
  initialState,
  reducers: {
    setConfig: (state, action: PayloadAction<Partial<AppConfig>>) => {
      return { ...state, ...action.payload };
    },
  },
});

export const { setConfig } = configSlice.actions;
export default configSlice;
